import { render } from "./AITools.vue?vue&type=template&id=18694adb&scoped=true"
import script from "./AITools.vue?vue&type=script&lang=js"
export * from "./AITools.vue?vue&type=script&lang=js"

import "./AITools.vue?vue&type=style&index=0&id=18694adb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18694adb"]])

export default __exports__